import { DiagonalStripes } from "../../Utils/Transitions/DiagonalStripes";
import { Game, eFontAsset } from "../../Game";
import { TIMER, Gameplay } from "../Gameplay";



const enum eState {
    hidden,
    showing,
    delay,
    hiding,
}



export class LevelIntro {
    /**
     * Udalost vyvolana po dokonceni zobrazeni intra do noveho levelu
     * Emitter: Gameplay.events
     * Parametry: NA
     */
    static readonly EVENT_COMPLETE = "lvlIntro";

    private _screenTransition: DiagonalStripes;
    private _msg: pc.Entity;

    private _state: eState;
    private _time: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        // Prechod mezi obrazovkami
        this._screenTransition = new DiagonalStripes(screen, Game.SCALE, TIMER, Gameplay.instance.events);
        this._screenTransition.eventHandler.on(DiagonalStripes.EVENT_COMPLETE, (dir: number): void => {
            if (dir > 0) {
                this._time = TIMER.time;
                this._state = eState.delay;
            }
            else {
                this._msg.enabled = false;
                this._state = eState.hidden;
            }
        });

        // Zobrazeni textu LEVEL X
        this._msg = new pc.Entity();
        this._msg.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            fontSize: 36,
            fontAsset: Game.APP.assets.find(eFontAsset.default, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
        });
        this._msg.element.shadowColor.set(0, 0, 0, 1);
        this._msg.element.shadowOffset.set(1, -1);
        this._msg.enabled = false;
        screen.addChild(this._msg);

        this._state = eState.hidden;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._state != eState.hidden) {
            this._state = eState.hidden;
            this._screenTransition.reset();
            this._msg.enabled = false;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(lvlNum: number): void {
        this._state = eState.showing;

        // Zprava
        this._msg.element.text = "LEVEL " + lvlNum;
        this._msg.element.opacity = 0;
        this._msg.enabled = true;

        // Zobrazit zavreni obrazovky
        if (!this._screenTransition.initialized)
            this._screenTransition.init(3, [new pc.Color(0.75, 0, 0), new pc.Color(0.5, 0, 0)]);

        this._screenTransition.start(500, 1, pc.CubicOut);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._state == eState.hidden)
            return;

        if (this._state != eState.delay) {
            if (this._screenTransition.active) {
                this._screenTransition.update();

                let progress = pc.CubicIn(this._screenTransition.progress);
                this._msg.element.opacity = (this._screenTransition.dir > 0 ? progress : 1 - progress);
            }
        }
        else if (this._time + 500 < TIMER.time) {
            Gameplay.instance.events.fire(LevelIntro.EVENT_COMPLETE);

            this._state = eState.hiding;
            this._screenTransition.start(500, -1, pc.CubicIn);
        }
    }
}